import ClientSearchByPhone from './components/ClientSearchByPhone';
import { ClientSearchByName } from './components/ClientSearchByName';
import Can from '../permissions/abilities/Can';

const ClientSearchPage = () => {
  return (
    <div>
      <ClientSearchByPhone />
      <Can do='available' on='reference.person.findByName'>
        <ClientSearchByName />
      </Can>
    </div>
  );
};

ClientSearchPage.displayName = 'ClientSearchPage';

export { ClientSearchPage };
